import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationCancel, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { AuthServiceInterface } from '../services/auth/auth-service.interface';

@Injectable()
export class AuthGuard {
  constructor(private router: Router, @Inject('AuthServiceInterface') private authService: AuthServiceInterface) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthorized() ? of(true) : of(false).pipe(tap(() => this.navigate(state)));
  }

  private navigate(state: RouterStateSnapshot): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationCancel),
        take(1)
      )
      .subscribe(({ url }: NavigationCancel) => {
        const params = Object.create({
          queryParams: {
            returnUrl: state.url,
            redirectPath: encodeURIComponent(state.url),
          },
        });
        if (url === '/') {
          params.queryParams.affiliatesURL = true;
        }
        this.router.navigate(['/auth/signin'], params);
      });
  }
}
